import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppInitRequestStatus } from '../enums/app-init-request-status.enum';
import { AppInitState } from './app-init.reducer';

export const selectAppInitState = createFeatureSelector<AppInitState>('appInit');

export const selectIsAppInitialized = createSelector(
  selectAppInitState,
  (state) => state.isInitialized
);

export const selectRequestStatus = (requestKey: string) =>
  createSelector(
    selectAppInitState,
    (state) => state.requestStatuses[requestKey]?.status || AppInitRequestStatus.Pending
  );

export const selectIsRequestComplete = (requestKey: string) =>
  createSelector(
    selectAppInitState,
    (state) => state.requestStatuses[requestKey]?.status === AppInitRequestStatus.Success
  );

export const selectIsRequestFailed = (requestKey: string) =>
  createSelector(
    selectAppInitState,
    (state) => state.requestStatuses[requestKey]?.status === AppInitRequestStatus.Failed
  );

export const selectRequiredRequests = createSelector(
  selectAppInitState,
  (state) => state.requiredRequests
);

export const selectAllRequestStatuses = createSelector(
  selectAppInitState,
  (state) => state.requestStatuses
);

